<div class="page has-breadcrumb">
  <astrobin-marketplace-listing-form (save)="onCreate($event)"></astrobin-marketplace-listing-form>
  <astrobin-scroll-to-top></astrobin-scroll-to-top>
</div>
